var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
export const ModalFooter = props => {
    const { withBorder = false, children, className } = props, rest = __rest(props, ["withBorder", "children", "className"]);
    return (React.createElement("div", Object.assign({ className: clsx('px-4 py-5 sm:p-6', !withBorder && 'pt-0 sm:pt-0', withBorder && 'border-t border-line-subdued', className) }, rest), children));
};
export const ModalActions = props => {
    const { withBorder = false, children, className } = props, rest = __rest(props, ["withBorder", "children", "className"]);
    return (React.createElement("div", Object.assign({ className: clsx('px-4 py-5 sm:p-6', 'flex flex-row-reverse space-s-2 space-s-reverse', !withBorder && 'pt-0 sm:pt-0', withBorder && 'border-t border-line-subdued', className) }, rest), children));
};
//# sourceMappingURL=ModalFooter.js.map